import classNames from 'classnames'
import { forwardRef, type FC, type ReactNode } from 'react'
import styles from './EmailEditor.module.scss'
import { EmailEnvelope } from './EmailEnvelope'

export interface EmailCanvasProps {
  className?: string
  children: ReactNode
}

export const EmailCanvas = forwardRef<HTMLDivElement, EmailCanvasProps>(({ className, children }, ref) => (
  <div ref={ref} className={classNames('position-relative border rounded-4 zocks-border-color-gray-200 zocks-bg-color-white pt-3 px-3 pb-4', className)}>
    {children}
  </div>
))
EmailCanvas.displayName = 'EmailCanvas'

export interface EmailPreviewCardProps {
  fromName: string
  subject: string
  body: string
  className?: string
  frameClassName?: string
  title?: string
}

export const EmailPreviewCard: FC<EmailPreviewCardProps> = ({ fromName, subject, body, className, frameClassName, title = 'Email preview' }) => (
  <EmailCanvas className={classNames('d-flex flex-column gap-3', className)}>
    <EmailEnvelope fromName={fromName} subject={subject} />
    <iframe sandbox='' srcDoc={body} title={title} className={classNames(frameClassName ?? styles.previewFrame, 'w-100 border-0 d-block')} />
  </EmailCanvas>
)
